import { Box } from "@material-ui/core";
import React from "react";
import { CorpSessionInfo, RewardsAccount, SessionInfo } from "redmond";
import { getCurrentCorpAccount, isCorpTenant } from "@capone/common";
import { FreeDisruptionRebookingSection } from "@capone-corporate/portal";
import { config } from "../../../api/config";
import AdminHomePageSection from "../AdminHomePageSection/component";
import ValuePropCarousel from "../ValuePropCarousel";
import "./styles.scss";

interface CorpHomePageBottomSectionProps {
  sessionInfo: SessionInfo | CorpSessionInfo;
  rewardsAccounts?: RewardsAccount[];
}

export const CorpHomePageBottomSection = ({
  sessionInfo,
  rewardsAccounts = [],
}: CorpHomePageBottomSectionProps) => {
  if (!isCorpTenant(config.TENANT)) return null;

  const currentAccount = getCurrentCorpAccount(rewardsAccounts, sessionInfo);

  return (
    <Box>
      <FreeDisruptionRebookingSection className="free-disruption-homepage-section"/>
      <ValuePropCarousel currentAccount={currentAccount} />
      <AdminHomePageSection sessionInfo={sessionInfo} />
    </Box>
  );
};
